import { Suspense, lazy } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import useAuthStore from "@Store/authStore";
import AppScreenLoader from "@Components/app-screen-loader";
import { AdminLayout } from "./polymet/layouts/admin-layout";
import { Toaster } from "react-hot-toast";
const Authenticated = lazy(() => import("@Navigation/AuthenticatedApp"));
const UnAuthenticated = lazy(() => import("@Navigation/UnAuthenticatedApp"));

// Build-time gate: flag lives HERE (not imported from bug-reporter.ts) so the SDK
// module isn't pulled into the main bundle. When false, Rollup drops the lazy
// import → `@koderlabs/tasks-sdk*` never ships and the reporter never mounts.
const REPORTER_ENABLED = import.meta.env.VITE_IT_REPORTER_ENABLED === "true";
const BugReporter = REPORTER_ENABLED
  ? lazy(() => import("@Components/bug-reporter"))
  : null;

export default function App() {
  const { isAuth, hasHydrated } = useAuthStore();

  if (!hasHydrated) {
    return <div className="min-h-screen bg-white" />;
  }

  return (
    <>
      <Router>
        <Suspense
          fallback={
            isAuth ? (
              <AdminLayout>
                <AppScreenLoader />
              </AdminLayout>
            ) : (
              <div className="min-h-screen bg-white" />
            )
          }
        >
          {isAuth ? <Authenticated /> : <UnAuthenticated />}
        </Suspense>
      </Router>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
        }}
      />
      {/* InstantTasks in-app bug reporter — only mounted (and only bundled) when
          VITE_IT_REPORTER_ENABLED === 'true'. Lazy → needs Suspense. */}
      {BugReporter && (
        <Suspense fallback={null}>
          <BugReporter />
        </Suspense>
      )}
    </>
  );
}
